module.exports = __webpack_public_path__ + "img/journal_add_note.56244a5c.svg";